// Default site content — kept in sync with backend DEFAULT_CONTENT in /app/backend/server.py.
// Used as the initial value of the ContentContext so pages render real text on first paint
// (no "Loading…" placeholder visible to crawlers).
export const DEFAULT_CONTENT = {
  hero_eyebrow: "",
  hero_title: "THE PILE HOOP THAT MINIMIZES PILING WEAR. NEVER RUSTS.",
  hero_subtitle:
    "USA-made marine pile hoops engineered for harsh dock conditions. Made of polypropylene, fiberglass, and the best UV inhibitor on the market.",
  hero_cta_label: "Request a Quote",
  marquee_text:
    "MADE IN USA — UV PROTECTED — FIBERGLASS REINFORCED — NEVER RUSTS — WITHSTANDS HARSH CONDITIONS",
  feature_1_title: "NEVER RUSTS",
  feature_1_body:
    "Built from polypropylene and fiberglass. Salt water has no effect. Zero corrosion, season after season.",
  feature_2_title: "UV PROTECTED",
  feature_2_body:
    "The best UV inhibitor available is engineered into every Pile Glide Pro.",
  feature_3_title: "REDUCES WEAR",
  feature_3_body:
    "Smooth glide surface absorbs impact and protects piling from the destructive grind of tide and wake.",
  product_intro:
    "The Pile Glide Pro is a pile hoop made in the USA of polypropylene, fiberglass, and the best UV inhibitor on the market. The result is a pile hoop that reduces piling wear, withstands harsh marine conditions, and never rusts.",
  sizes_note:
    "Available in three sizes. Built to fit standard marine pilings.",
  sizes_fit_note:
    'Select a Pile Glide Pro at least 1" larger than your Pile\'s diameter for proper fit.',
  about_title: "",
  about_body: "",
  contact_email: "securestaymarine@outlook.com",
  contact_phone: "",
  contact_address:
    "Secure Stay Marine Products, 295 Seven Farms Drive, Suite-C-262, Daniel Island, SC 29492",
  footer_tagline: "SECURE YOUR DOCK.",
};
